import { MAX_QUESTION_LENGTH } from './constants'
import { SlideQuestionErrorKeys } from './keys'
import { type ValidationError, type Validator } from './types'

export const validateTutorBot: Validator = async (context, question) => {
  const errors: ValidationError[] = []
  const trimmedScript = question.question?.trim()

  if (!trimmedScript) {
    // errors.push({
    //   field: 'question',
    //   key: SlideQuestionErrorKeys.question_tutor_bot_script_missing,
    // })
  } else if (trimmedScript.length > MAX_QUESTION_LENGTH) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_tutor_bot_script_too_long,
    })
  }

  return errors
}

export const validateModeratorBot: Validator = async (context, question) => {
  const errors: ValidationError[] = []
  const trimmedScript = question.question?.trim()

  if (!trimmedScript) {
    // errors.push({
    //   field: 'question',
    //   key: SlideQuestionErrorKeys.question_moderator_bot_script_missing,
    // })
  } else if (trimmedScript.length > MAX_QUESTION_LENGTH) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_moderator_bot_script_too_long,
    })
  }

  return errors
}

export const validateGraderBot: Validator = async (context, question) => {
  const errors: ValidationError[] = []
  const trimmedScript = question.question?.trim()

  if (!trimmedScript) {
    // errors.push({
    //   field: 'question',
    //   key: SlideQuestionErrorKeys.question_grader_bot_script_missing,
    // })
  } else if (trimmedScript.length > MAX_QUESTION_LENGTH) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_grader_bot_script_too_long,
    })
  }

  return errors
}

export const validateRolePlayBot: Validator = async (context, question) => {
  const errors: ValidationError[] = []
  const trimmedScript = question.question?.trim()

  if (!trimmedScript) {
    // errors.push({
    //   field: 'question',
    //   key: SlideQuestionErrorKeys.question_role_play_bot_script_missing,
    // })
  } else if (trimmedScript.length > MAX_QUESTION_LENGTH) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_role_play_bot_script_too_long,
    })
  }

  return errors
}
